export const ASSET_BASE = (
  process.env.REACT_APP_ASSET_BASE || `${process.env.PUBLIC_URL || ''}/assets/ppt-extracted`
).replace(/\/+$/, '');
export const DEMO_INPUT = `${ASSET_BASE}/input-example-1.png`;
export const DEMO_RESULT = `${ASSET_BASE}/output-example-1.png`;
export const DEMO_MODEL = `${ASSET_BASE}/object_0%20%281%29.glb`;

export const demoPairs = [
  {
    input: `${ASSET_BASE}/input-example-1.png`,
    output: `${ASSET_BASE}/output-example-1.png`,
    label: 'Mechanical bracket upright view',
  },
  {
    input: `${ASSET_BASE}/input-example-2.png`,
    output: `${ASSET_BASE}/output-example-2.png`,
    label: 'Mechanical bracket top view',
  },
];

export const mockedResult = {
  status: 'completed',
  resultType: 'model',
  thumbnailUrl: DEMO_RESULT,
  modelUrl: DEMO_MODEL,
  frames: [],
};
